import type { CoachJourney } from './schema';
import type { CoachRun } from './engine';

export interface CoachProgress {
  current: number;
  total: number;
  unit: 'chapter' | 'step';
  items: { id: string; title: string }[];
}

/** A stable outline: recovery branches share their chapter; hidden setup isn't a user step. */
export function journeyProgress(journey: CoachJourney, run: CoachRun): CoachProgress | null {
  const index = journey.steps.findIndex(step => step.id === run.stepId);
  if (index < 0 || run.journeyId !== journey.id) return null;
  const chapters = [
    ...new Set(journey.steps.flatMap(step => (step.chapter ? [step.chapter] : []))),
  ];
  if (chapters.length) {
    chapters.sort((a, b) => a - b);
    const chapter = journey.steps
      .slice(0, index + 1)
      .reverse()
      .find(step => step.chapter)?.chapter;
    return {
      current: chapter ? chapters.indexOf(chapter) + 1 : 1,
      total: chapters.length,
      unit: 'chapter',
      items: chapters.map(number => {
        const first = journey.steps.find(step => step.chapter === number)!;
        return { id: String(number), title: first.title };
      }),
    };
  }
  const cards = journey.steps.filter(step => step.display === 'card' || step.display === 'inline');
  if (!cards.length) return null;
  const reached = journey.steps.slice(0, index + 1).filter(step => cards.includes(step)).length;
  return {
    current: Math.max(1, reached),
    total: cards.length,
    unit: 'step',
    items: cards.map(step => ({ id: step.id, title: step.title })),
  };
}
